/* The way in, in ONAM's style: the landing moment (/home) and the console hub (/entry-hub).
   MAP's Orbit and Orbit2 keep all their logic (permissions, landing page, console state)
   and render these instead of the atom diagram. */

import React from "react";
import { Glyph, Loader64, reducedMotion } from "../mark";
import "../onam.css";
import "../onam-map.css";
import "../chrome/chrome.css";

export interface HubCard { title: string; desc: string; live: boolean; cta?: string; state?: string; onClick: () => void }

/** /home: shown for a moment while MAP works out where to send you. */
export function OnamLanding() {
  return (
    <div className="onam-app hub onam-frame">
      <div className="landing" role="status" aria-label="Loading">
        <div className="hub-mark"><Loader64 lap="1.6s" /></div>
        <span className="label">Getting things ready</span>
      </div>
    </div>
  );
}

/** /entry-hub: Discover, Engage and Measure, then the cards inside each console.
    The brand block on the left is exactly as tall as the cards: mark on top, name at the bottom. */
export function OnamHub({ console: con, cards, onBack }: { console: string | null; cards: HubCard[]; greeting?: string; onBack: () => void }) {
  return (
    <div className="onam-app hub onam-frame">
      <main className={`view ${reducedMotion() ? "" : "enter"}`} key={con || "home"}>
        <section className={`hubp ${con ? "console" : "home"}`}>
          <div className="hub-brand">
            <div className="hub-id">
              <div className="hub-mark"><Loader64 lap="1.6s" /></div>
              {con ? <h1 className="hub-word">{con}</h1> : <h1 className="sr-only">ONAM by Saptharushi</h1>}
            </div>
            {con ? <button className="hub-back" onClick={onBack}><Glyph n="arrow" /> Back to ONAM</button> : null}
          </div>
          <div className="hub-right"><div className="hub-cards">
            {cards.map((c, i) => (
              <button key={c.title} className={`hcard ${c.live ? "live" : "muted"}`} style={{ ["--i" as any]: i }} onClick={c.onClick}>
                <span className="hc-top"><span className="t-dim">{String(i + 1).padStart(2, "0")}</span>{c.live ? <span className="st confirm">Live</span> : <span className="st idle">{c.state || "Coming soon"}</span>}</span>
                <span className="hc-t">{c.title}</span><span className="hc-d">{c.desc}</span>
                <span className="hc-go">{c.live ? <><span>{c.cta}</span><span className="arrowc"><Glyph n="arrow" /></span></> : <span />}</span>
              </button>))}
          </div></div>
        </section>
      </main>
    </div>
  );
}
